module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-1",
    staticStyle: {
      "width": "170px",
      "flex": "none"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Nhập tên tàu"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.loadDataTau()
      }
    },
    model: {
      value: (_vm.nameOfShip),
      callback: function($$v) {
        _vm.nameOfShip = $$v
      },
      expression: "nameOfShip"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 mr-2 py-0 my-0",
    staticStyle: {
      "text-transform": "none",
      "color": "#1d52e8"
    },
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.loadDataTau()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "17"
    }
  }, [_vm._v("search")]), _vm._v(" Tìm kiếm")], 1)], 1), _vm._v(" "), (_vm.loadingDataItem) ? _c('content-placeholders', [_c('content-placeholders-img'), _vm._v(" "), _c('content-placeholders-heading')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataItems), function(value, name) {
    return _c('div', [_c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n      " + _vm._s(value[0]['portRegionName'] || '') + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3",
      staticStyle: {
        "overflow": "auto"
      }
    }, [_c('v-data-table', {
      staticClass: "table-bordered danhSachHoSoTable__class",
      attrs: {
        "headers": _vm.headersKhDieuDong,
        "items": value,
        "hide-actions": "",
        "no-data-text": 'Không tìm thấy hồ sơ ',
        "no-results-text": 'Không tìm thấy hồ sơ '
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(props) {
          return [_c('tr', {
            staticStyle: {
              "background": "#316BB6",
              "color": "#ffff"
            }
          }, [_c('th', [_c('v-checkbox', {
            on: {
              "change": function($event) {
                _vm.changeSelectAll(value)
              }
            },
            model: {
              value: (_vm.selectAll),
              callback: function($$v) {
                _vm.selectAll = $$v
              },
              expression: "selectAll"
            }
          })], 1), _vm._v(" "), _vm._l((props.headers), function(header) {
            return (header['id'] !== 'checkbox') ? _c('th', {
              staticStyle: {
                "color": "#ffff !important",
                "font-weight": "normal !important"
              },
              domProps: {
                "innerHTML": _vm._s(header.text)
              }
            }) : _vm._e()
          })], 2)]
        }
      }, {
        key: "items",
        fn: function(props) {
          return [_c('td', [_c('v-checkbox', {
            attrs: {
              "value": props.item
            },
            model: {
              value: (_vm.selectItems),
              callback: function($$v) {
                _vm.selectItems = $$v
              },
              expression: "selectItems"
            }
          })], 1), _vm._v(" "), _vm._l((_vm.headersKhDieuDong), function(itemKey, index) {
            return (itemKey['id'] !== 'checkbox') ? _c('td', {
              staticClass: "text-xs-center"
            }, [(itemKey.id === 'chanelCodeList') ? _c('span', _vm._l((props.item[itemKey.display]), function(item, index) {
              return _c('div', {
                key: 'chanelCodeList' + index
              }, [_vm._v(_vm._s(item))])
            })) : (itemKey.id === 'portHarbourCode') ? _c('span', [_c('span', [_vm._v(_vm._s(props.item['portHarbourName']) + ", " + _vm._s(props.item['portWharfName']))])]) : _c('span', [_vm._v(_vm._s(props.item[itemKey.display]))])]) : _vm._e()
          })]
        }
      }])
    })], 1)])
  }), _vm._v(" "), _vm._l((_vm.arrNotData), function(item) {
    return _c('div', {
      staticClass: "caption-header mt-3"
    }, [_vm._v("\n    " + _vm._s(item) + "\n  ")])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-tra-cuu"
  }, [_c('span', {
    staticClass: "ml-3"
  }, [_vm._v("Tàu thuyền trong cảng ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03122ad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TauTrongCang.vue
// module id = 718
// module chunks = 1